import { render, staticRenderFns } from "./LandingFaqRef.vue?vue&type=template&id=d0c7ee2e&scoped=true"
import script from "./LandingFaqRef.vue?vue&type=script&lang=js"
export * from "./LandingFaqRef.vue?vue&type=script&lang=js"
import style0 from "./LandingFaqRef.vue?vue&type=style&index=0&id=d0c7ee2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c7ee2e",
  null
  
)

export default component.exports